import { render } from "./moneyListCenterChild.vue?vue&type=template&id=e960e61e&scoped=true"
import script from "./moneyListCenterChild.vue?vue&type=script&lang=js"
export * from "./moneyListCenterChild.vue?vue&type=script&lang=js"

import "./moneyListCenterChild.vue?vue&type=style&index=0&id=e960e61e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e960e61e"]])

export default __exports__